import { useTranslation } from "react-i18next";
import DiaryValuesLineChart from "../diary/DiaryValuesLineChart";

const transformLabTestsToDataSets = (labTests, t) => {
  const transformedData = [];

  labTests?.forEach((test) => {
    const testDate = test?.testDate;

    test?.labParams?.forEach((param) => {
      let paramName = param?.parameterName;
      let hours = "";

      if (test?.labTestName === "plasma_concentration_test") {
        hours = paramName.split("&&")[1];
        paramName = paramName.split("&&")[0]?.split("##")[0];
        paramName = "plasma_concentration_test" + "+" + paramName + "+" + hours;
      }

      const value = parseFloat(param?.value);
      const unit = param?.unit;

      let existingEntry = transformedData?.find(
        (entry) => entry?.label === paramName,
      );

      if (!existingEntry) {
        existingEntry = {
          label: t(paramName),
          data: [],
          connectPoints: true,
        };

        transformedData?.push(existingEntry);
      }

      existingEntry?.data?.push({
        x: testDate,
        y: value,
        value: value,
        unit: unit,
      });
    });
  });

  return transformedData;
};

const LabTestsLineChart = ({
  labTests,
  patientId,
  onCloseDialog,
  showDialog,
}) => {
  const { t } = useTranslation();
  const values = transformLabTestsToDataSets(labTests, t);

  return (
    <DiaryValuesLineChart
      header={t("lab_tests_line_chart")}
      values={values}
      showDialog={showDialog}
      onCloseDialog={onCloseDialog}
      patientId={patientId}
    />
  );
};

export default LabTestsLineChart;
